/**
 * The app's KPI-drill registry (AVA-560): which side-panel list opens for each entity a dashboard
 * column can identify. The decision logic is in utils/listDrill.js; this module only wires the
 * entries to the store and the side panel.
 *
 * Adding a list: append an entry with the entity (+ tagKind for tags), its copy, an optional
 * permission gate and an open({ ids, total }) that shows the list filtered to those ids.
 */
import store from '@/store';
import { $has } from '@/utils';
import permissions from '@Share/config/permissions';
import { PANEL_TAB } from '@/constants/tabs';
import {
  LIST_DRILL_ENTITY,
  LIST_DRILL_TAG_KIND,
  createListDrillRegistry,
} from '../utils/listDrill';
import { createDashboardIdFilter } from '@/features/Tags/utils/avaInspectDashboardFilter';

/**
 * AVA Inspect list in "dashboard filter" mode: store the ids for the current facility, then open
 * the Condition Map panel through the legacy SHOW_PANEL, which bridges to GENERAL/OPEN_PANEL
 * (TAB_TO_PANEL_MAP in src/store/index.js). The panel reacts to the filter: amisList switches to
 * its AVA Inspections tab and AvaInspectionPanel (re)loads the list, also when it is already open.
 */
function openAvaInspectList({ ids, total }) {
  const filter = createDashboardIdFilter({ ids, total, facilityId: store.state.assetId });
  if (!filter) throw new Error('No facility is open, so the AVA Inspect list cannot be filtered.');
  store.commit('AVA_INSPECT/SET_DASHBOARD_ID_FILTER', filter);
  return store.dispatch('SHOW_PANEL', { tabIndex: PANEL_TAB.INSPECTION });
}

export const LIST_DRILL_REGISTRY = createListDrillRegistry([
  {
    entity: LIST_DRILL_ENTITY.TAG,
    tagKind: LIST_DRILL_TAG_KIND.AVA_INSPECT,
    emptyMessage: 'No AVA Inspects match the current dashboard filters',
    truncatedNoun: 'AVA Inspects',
    canOpen: () => $has(permissions.Tags.AvaInspect.View),
    deniedMessage: 'You do not have permission to view the AVA Inspect list.',
    open: openAvaInspectList,
  },
]);
